var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        attrs: {
          "row-key": "name",
          color: "secondary",
          data: _vm.gridData,
          columns: _vm.computedColumns,
          loading: _vm.loading,
          pagination: _vm.pagination,
          selection: _vm.selectable.type,
          selected: _vm.selectable.selected
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          },
          "update:selected": function($event) {
            _vm.$set(_vm.selectable, "selected", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top-left",
            fn: function(props) {
              return _c(
                "div",
                {
                  staticClass: "row justify-start fit",
                  attrs: { id: "rowActions" }
                },
                [
                  _vm.dirtyDataMap.filter(function(item) {
                    return item
                  }).length != 0
                    ? _c(
                        "div",
                        {
                          staticClass: "rowButtons",
                          attrs: { "auto-width": "" }
                        },
                        [
                          _c("q-btn", {
                            staticClass: "confirmUpdate",
                            attrs: { icon: "check", color: "green" },
                            on: {
                              click: function($event) {
                                _vm.test(_vm.dirtyDataMap)
                              }
                            }
                          }),
                          _c("q-btn", {
                            staticClass: "cancelUpdate",
                            attrs: { icon: "clear", color: "red" },
                            on: {
                              click: function($event) {
                                _vm.clearUpdate(props)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            }
          },
          {
            key: "top-right",
            fn: function(props) {
              return _c(
                "div",
                {
                  staticClass: "row justify-end fit",
                  attrs: { id: "gridActions" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "row justify-end" },
                    [
                      _c("q-btn", {
                        ref: "gridRefresh",
                        attrs: {
                          outline: "",
                          rounded: "",
                          color: "grey",
                          icon: "cached",
                          align: "left"
                        },
                        on: {
                          click: function($event) {
                            _vm.refresh()
                          }
                        }
                      }),
                      _vm._v(" \n        "),
                      _c("q-btn", {
                        attrs: {
                          outline: "",
                          rounded: "",
                          align: "left",
                          icon: props.inFullscreen
                            ? "fullscreen_exit"
                            : "fullscreen"
                        },
                        on: { click: props.toggleFullscreen }
                      }),
                      _vm._v(" \n        "),
                      _c("q-btn", {
                        attrs: {
                          outline: "",
                          rounded: "",
                          align: "left",
                          color: "primary",
                          icon: "archive"
                        },
                        on: {
                          click: function($event) {
                            _vm.exportGrid()
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                {},
                [
                  props.multipleSelect
                    ? _c(
                        "q-th",
                        {
                          staticClass: "float-left",
                          attrs: { id: "selectColumnHeader" }
                        },
                        [
                          _c("q-checkbox", {
                            staticClass: "float-left",
                            attrs: { "indeterminate-value": "some" },
                            model: {
                              value: props.selected,
                              callback: function($$v) {
                                _vm.$set(props, "selected", $$v)
                              },
                              expression: "props.selected"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._l(props.cols, function(col) {
                    return _c(
                      "q-th",
                      {
                        key: col.name,
                        attrs: {
                          id: "columnHeaders",
                          "auto-width": "",
                          props: props
                        }
                      },
                      [
                        col.type === Number
                          ? _c("span", { staticClass: "text-right" }, [
                              _vm._v(" " + _vm._s(col.label) + " ")
                            ])
                          : _c("span", { staticClass: "text-left" }, [
                              _vm._v(" " + _vm._s(col.label) + " ")
                            ]),
                        col.filter
                          ? _c(
                              "q-td",
                              {
                                staticClass: "float-right",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-10" },
                                    [_c("q-field", [_c("q-input")], 1)],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-2",
                                      attrs: { id: "filterRow" }
                                    },
                                    [
                                      _c("q-btn", {
                                        staticClass: "q-mx-md filterButton",
                                        attrs: { icon: "filter_list" }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  })
                ],
                2
              )
            }
          },
          {
            key: "top-row",
            fn: function(props) {
              return [
                _vm._t(
                  "add-row",
                  [
                    _vm.addSlot
                      ? _c(
                          "q-tr",
                          { attrs: { id: "addRow", props: props } },
                          [
                            props.multipleSelect
                              ? _c("q-td", { attrs: { "auto-width": "" } })
                              : _vm._e(),
                            _vm._l(props.cols, function(col) {
                              return _c("q-td", {
                                key: col.name,
                                attrs: { "auto-width": "" }
                              })
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  { props: props }
                )
              ]
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  {
                    class: { dirty: _vm.dirtyDataMap[props.row.__index] },
                    attrs: { props: props }
                  },
                  [
                    _c(
                      "q-td",
                      { attrs: { "auto-width": "" } },
                      [
                        _c("q-checkbox", {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.test(props)
                            }
                          },
                          model: {
                            value: props.selected,
                            callback: function($$v) {
                              _vm.$set(props, "selected", $$v)
                            },
                            expression: "props.selected"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._l(props.cols, function(col) {
                      return _vm.editable || col.editable
                        ? _c(
                            "q-td",
                            { key: col.name, attrs: { props: props } },
                            [
                              col.type === String
                                ? _c("q-input", {
                                    attrs: { type: "text", value: col.value },
                                    on: {
                                      input: function(newVal) {
                                        return _vm.updateColumn(
                                          newVal,
                                          props,
                                          col
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              col.type === Number
                                ? _c("q-input", {
                                    attrs: {
                                      type: "number",
                                      align: "right",
                                      value: col.value
                                    },
                                    on: {
                                      input: function(newVal) {
                                        return _vm.updateColumn(
                                          newVal,
                                          props,
                                          col
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              col.type === Boolean
                                ? _c("q-toggle", {
                                    attrs: { value: col.value, color: "green" },
                                    on: {
                                      input: function(newVal) {
                                        return _vm.updateColumn(
                                          newVal,
                                          props,
                                          col
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _c("q-td", [
                            col.type === Number
                              ? _c("span", { staticClass: "float-right" }, [
                                  _vm._v(_vm._s(col.value) + " ")
                                ])
                              : _c("span", [
                                  _vm._v(" " + _vm._s(col.value) + " ")
                                ])
                          ])
                    })
                  ],
                  2
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }